<template>
    <div class="header-common-container">
        <div class="logo-container">
                        <!-- <img src="~@/assets/logo.png"/> -->
                        <!-- <img src="~@/assets/images/44.png"  alt="">
                        &nbsp;自动驾驶权限登录管理平台 -->
                        <div class="t_img1"><img src="~@/assets/images/44.png"  alt=""></div>
                        <div class="t_fant">自动驾驶登录权限管理平台</div>
                    </div>
        <div class="right-box">
            <robo-system-dropdown/>
        </div>
    </div>
</template>
<script>
import roboSystemDropdown from '../robo-system-dropdown/robo-system-dropdown';

export default {
    name: '',
    components: {
        roboSystemDropdown
    },
    data() {
        return {};
    },
    mounted() {
    },
    methods: {}
};
</script>

<style lang="less">
    .header-common-container {
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
     .logo-container {
        // height: 112px;
        line-height: 64px;
        // background: inherit;
        width: 400px;
        color: #f3f6ff;
        font-size: 15px;
        // font-weight: bold;
        .t_fant{
            margin-left: 50px;
            width: 220px;
        }
        img {
            width: 65px;
            height: 21px;
            vertical-align: text-bottom;
            margin-left: 5px;
        }


    }
    .t_img1{
    width: 89px;
    height: 27px;
    float: left;
    margin-top: 3px;
    margin-top: 3px;
    // background: url('../44.png');
}

</style>
